//TODO:  settings will eventually live in the store but for now we can build selectors that will return the default values

export const getForumUrl = state => {
  return "https://forum.spaffnerds.com";
};
